export default __webpack_public_path__ + "static/media/sales-reports-img-homepage.0f6b8206.png";